export default {
  title: {
    id: 'bo_sellers-opportunities-pricing-backboxes_to_boost-title',
    defaultMessage: 'Backboxes to boost',
  },
  subtitle: {
    id: 'bo_sellers-opportunities-pricing-backboxes_to_boost-subtitle',
    defaultMessage:
      'You’ve won the BackBoxes, but these items still aren’t selling. Drop your prices to start moving inventory.',
  },
  info: {
    id: 'bo_sellers-opportunities-pricing-backboxes_to_boost-info',
    defaultMessage: 'Boost {count} BackBoxes.',
  },
  success: {
    id: 'bo_sellers-opportunities-pricing-backboxes_to_boost-success',
    defaultMessage: 'Nice work. Your items are priced to sell.',
  },
  fetchingData: {
    id: 'bo_sellers-opportunities-pricing-fetching_data',
    defaultMessage: 'Fetching opportunities',
  },
  saveTime: {
    id: 'bo_sellers-opportunities-pricing-backboxes_to_boost-save_time',
    defaultMessage: 'Save time by updating all BackBox prices at once.',
  },
  items: {
    id: 'bo_sellers-opportunities-pricing-backboxes_to_boost-items',
    defaultMessage: `{count, plural,
      =0 {0 item}
      one {# item}
      other {# items}
    }`,
  },
}
